/** Helper functions for manipulating Favicon.
 * Mixpanel Favicons are hosted by our marketing-site CDN and
 * live at analytics/marketing-site/public/favicons
 */

const faviconBadge16 = `https://cdn.mxpnl.com/marketing-site/static/favicons/favicon-16-badge.png`;
const faviconBadge32 = `https://cdn.mxpnl.com/marketing-site/static/favicons/favicon-32-badge.png`;

const favicon16 = `https://cdn.mxpnl.com/marketing-site/static/favicons/favicon-16x16.png`;
const favicon32 = `https://cdn.mxpnl.com/marketing-site/static/favicons/favicon-32x32.png`;

export const REPORT_LOADED_COPY = `Report Loaded`;
const Size16 = `16x16`;
const Size32 = `32x32`;
let previousDocumentTitle = ``;

export const faviconUtils = {
  isDocumentHidden,
};

export function isDocumentHidden() {
  return document.hidden;
}

function showRegularFaviconCallBack() {
  updateFavicon({useBadge: false});
  document.title = previousDocumentTitle;
  document.removeEventListener(`mousemove`, showRegularFaviconCallBack);
}

export function updateFavicon({useBadge} = {useBadge: true}) {
  document.addEventListener(`mousemove`, showRegularFaviconCallBack);
  if (document.title !== REPORT_LOADED_COPY) {
    previousDocumentTitle = document.title;
  }
  // only update the favicon if a user is not active
  const shouldUpdateFavicon = useBadge && faviconUtils.isDocumentHidden();
  document.querySelectorAll(`link[rel~='icon']`).forEach((link) => {
    if (link instanceof HTMLLinkElement) {
      const linkSizes = link.getAttribute(`sizes`);
      if (linkSizes === Size16) {
        if (shouldUpdateFavicon) {
          document.title = REPORT_LOADED_COPY;
          link.href = faviconBadge16;
        } else {
          link.href = favicon16;
        }
      } else if (linkSizes === Size32) {
        if (shouldUpdateFavicon) {
          document.title = REPORT_LOADED_COPY;
          link.href = faviconBadge32;
        } else {
          link.href = favicon32;
        }
      }
    }
  });
}
